import React from 'react';
import styled from 'styled-components';

import { FiPlus, FiMinus } from "react-icons/fi";


const Wrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 100%;
    min-width: 100px;
    max-width: 6vw;
    padding-bottom: 5px;

    button{
        text-align: center;
        display: grid;
        place-items: center;
        width: 24px;
        height: 24px;
        border: 1px solid var(--darkgreen);
        border-radius: 2px;

        cursor: pointer;

        transition: 250ms background-color;

        .icon{
            color: var(--darkgreen);
        }

        &:hover{
            background-color: rgba(0, 0, 0, 0.075);
        }

        &:disabled
        {
            .icon{
                color: #a7a8ab;;
            }
            background-color: rgba(0, 0, 0, 0.05);
            border: 1px solid #a7a8ab;
        }
    }

    .quantity{
        font-family: IBM Plex Mono Bold;
        margin: 0 5px;
    }
    
    @media(max-width: 1000px)
    {
        max-width: none;        
        button{
            height: 35px;
            width: 35px;

            .icon{
                height: 60%;
                width: 60%;
            }
        }

        p{
            font-size: 2.5vh;
        }
    }

`;

export default function QuantitySelector({ quantity, setQuantity })
{
    const increaseQuantity = (e) => {
        e.preventDefault();
        setQuantity((q) => q + 1);
    }

    const decreaseQuantity = (e) => {
        e.preventDefault();
        setQuantity((q) => q - 1);
    }

    return(
        <Wrapper>
            <button onClick={decreaseQuantity} disabled={quantity <= 1}>
                <FiMinus className="icon"/>
            </button>

            <p className="quantity">{quantity}</p>

            <button onClick={increaseQuantity}>
                <FiPlus className="icon"/>
            </button>
        </Wrapper>
    )
}